module.exports = __webpack_public_path__ + "img/x.686ca4b2.jpg";